<template>
  <button type="button" @click="$emit('clicked')" :class="color">{{ name }}</button>
</template>

<script setup lang="ts">
const props = defineProps({
  name: { type: String, required: true },
  color: { type: String }
  // placeholder: { type: String}
  //id: { type: String, required: true }
  // lineItems: { type: Array, required: true },
  // netValue: { type: Number, required:true},   //TODO remove?
  // netTax: { type:Number, required:true}   //TODO remove?
})

const emits = defineEmits(['clicked'])

//const model = defineModel<any>({ required: true });
</script>

<style lang="css" scoped>
.red {
  background-color: var(--red);
  border-color: var(--red);
}
button {
  /*margin-right: 0.5rem;*/
  margin-top: 0.5rem;
}

/*
button{
    color: white;
    font-size: 0.875rem;
    line-height: 1.25rem;
    height: 2rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    margin-top: 0.75rem;
    background-color: rgb(14 165 233);
    border: 2px solid rgb(14 165 233);
    border-radius: 0.375rem;
    cursor: pointer;

}

button:hover{
    color: black;
}

button:active{
    border: 2px solid black;
}*/
</style>
